
import OrderHistory from './OrderHistory';
import PNLHistory from './PNLHistory';
import CopyHistory from './CopyHistory';
import CommissionHistory from './CommissionHistory';
import RankHistory from './RankHistory';
import StyledTab from '@/views/components/StyledTab/StyledTab';
import Wrapper from '@/views/components/Wrapper/Wrapper';
import { useTranslation } from 'react-i18next';

export default function MasterTradeHistoryComponent() {
  const { t } = useTranslation()

  const TABS = [
    {
      label: t('copytrade.masterTradeHistory.orderHistory'),
      Panel: <OrderHistory/>
    },
    {
      label: t('copytrade.masterTradeHistory.pnlHistory'),
      Panel: <PNLHistory />
    },
    {
      label: t('copytrade.masterTradeHistory.copyHistory'),
      Panel: <CopyHistory />
    },
    {
      label: t('copytrade.masterTradeHistory.commissionHistory'),
      Panel: <CommissionHistory />
    },
    {
      label: t('copytrade.masterTradeHistory.rankHistory'),
      Panel: <RankHistory />
    },
  ]
  
  return (
    <Wrapper>
      <StyledTab tabs={TABS}></StyledTab>
    </Wrapper>
  );
}